import fingerprintjs2 from 'fingerprintjs2';
import axios from 'axios';
import Vue from 'vue';
import { gradeStrList, gradeStrListshort } from '@/utils/dictionary.js';

import BigNumber from 'bignumber.js';

// 获取url参数
export function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  // if(r != null) return r[2];
  if (r != null) return decodeURIComponent(r[2]);
  // if(r != null) return unescape(r[2]);
  return null;
}

// 判断是否是正确的手机号码
export function isPhone(phone) {
  return /^1[2,3,4,5,6,7,8,9]\d{9}$/g.test(phone);
}

/**
 * 读取本地图片
 * @param {FILE} file
 */
export function readFileOfImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      resolve(e.target.result);
    };
    reader.onerror = function(error) {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
}

// 获取浏览器指纹
export function getDeviceFinger() {
  return new Promise((resolve, reject) => {
    let device_finger_str = '';
    if (window.requestIdleCallback) {
      requestIdleCallback(function() {
        fingerprintjs2.get({}, function(components) {
          const values = components.map(function(component) {
            return component.value;
          });
          device_finger_str = fingerprintjs2.x64hash128(values.join(''), 31);
          resolve(device_finger_str);
        });
      });
    } else {
      setTimeout(function() {
        fingerprintjs2.get({}, function(components) {
          const values = components.map(function(component) {
            return component.value;
          });
          device_finger_str = fingerprintjs2.x64hash128(values.join(''), 31);
          resolve(device_finger_str);
        });
      }, 500);
    }
  });
}

// 生成笛卡尔积
export function descartes(array) {
  if (array.length < 2) return array[0] || [];

  return [].reduce.call(array, function(col, set) {
    var res = [];
    col.forEach(function(c) {
      set.forEach(function(s) {
        var t = [].concat(Array.isArray(c) ? c : [c]);
        t.push(s);
        res.push(t);
      });
    });
    return res;
  });
}

// 判断是否是 https 访问
export function isHttps() {
  return window.location.protocol.endsWith('https:');
}

// 休眠
export function sleep(time = 100) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

// 对象 转  url 参数
export function queryParams(data, isPrefix = false) {
  const prefix = isPrefix ? '?' : '';
  const _result = [];
  for (const key in data) {
    const value = data[key];
    // 去掉为空的参数
    if (['', undefined, null].includes(value)) {
      continue;
    }
    if (value.constructor === Array) {
      value.forEach((_value) => {
        _result.push(
          encodeURIComponent(key) + '[]=' + encodeURIComponent(_value)
        );
      });
    } else {
      _result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  }

  return _result.length ? prefix + _result.join('&') : '';
}

export function deepCopy(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error');
  }
  var targetObj = source.constructor === Array ? [] : {};
  for (var keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepCopy(source[keys]);
      } else {
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}

// 清除对象中值为空的属性
export function filterParams(obj) {
  var _newPar = {};
  for (var key in obj) {
    if (
      (obj[key] === 0 || obj[key] === false || obj[key]) &&
      obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== ''
    ) {
      _newPar[key] = obj[key];
    }
  }
  return _newPar;
}
// 分转元
export function getYuan(money) {
  if (money != '') {
    const num = Number(money);
    const myMoney = num / 100;
    return myMoney;
  } else {
    return 0;
  }
}
// 元转分
export function getFen(money) {
  if (money != '') {
    const num = Number(money);
    const myMoney = num * 100;
    return myMoney;
  } else {
    return 0;
  }
}
// 导出
export function downloadReport(url, params, _this) {
  const token = localStorage.getItem('loginToken');
  if (_this) {
    _this.$Spin.show();
  }
  return axios({
    url: url,
    method: 'get',
    responseType: 'blob',
    params: params,
    headers: {
      token: token
    }
  }).then((res) => {
    if (_this) {
      _this.$Spin.hide();
    }
    if (!res) {
      Vue.prototype.$Message.warning({
        content: '下载模板文件失败',
        type: 'error',
        duration: 1
      });
      return false;
    }
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
    });
    const downloadElement = document.createElement('a');
    const href = window.URL.createObjectURL(blob);
    if (
      !res.headers['content-disposition'] &&
      !res.headers['Content-Disposition']
    ) {
      console.log(res.data, blob.slice());
      Vue.prototype.$Message.warning({
        content: '下载失败',
        type: 'error',
        duration: 1
      });
      return;
    }
    const contentDisposition = decodeURIComponent(
      res.headers['content-disposition'] || res.headers['Content-Disposition']
    ); // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;

    const patt = new RegExp('filename\\*=([^;]+\\.[^\\.;]+);*');
    const result = patt.exec(contentDisposition);
    const params = result[1].split("'");
    const filename = params[params.length - 1];
    console.log('文件名:', filename);
    // const filename = 'a.log'
    downloadElement.style.display = 'none';
    downloadElement.href = href;
    downloadElement.download = filename; // 下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载
    document.body.removeChild(downloadElement); // 下载完成移除元素
    window.URL.revokeObjectURL(href); // 释放掉blob对象
  });
}
Date.prototype.Format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return fmt;
};
// 时间戳格式化
export function formatTime(timeStamps, fmt = 'yyyy-MM-dd') {
  return new Date(timeStamps).Format(fmt);
}
// 时间戳格式化 到小时
export function formatTimeHour(timeStamps, fmt = 'yyyy-MM-dd hh:mm') {
  return new Date(timeStamps).Format(fmt);
}
// 时间戳格式化 时分
export function formatHour(timeStamps, fmt = 'hh:mm') {
  return new Date(timeStamps).Format(fmt);
}

/* 日期字符串转时间戳(秒)*/
export function dateToTimestamp(datestr) {
  datestr = datestr.replace(/-/g, '/');
  return Math.floor(new Date(datestr).getTime() / 1000);
}
// 数组转为,号隔开字符
export function getText(arr) {
  var str = '';
  for (var i = 0; i < arr.length; i++) {
    str += arr[i] + ',';
  }
  // 去掉最后一个逗号(如果不需要去掉，就不用写)
  if (str.length > 0) {
    str = str.substr(0, str.length - 1);
  }
  return str;
}
export function getWeek(date) {
  // 按周日为一周的最后一天计算
  var date = new Date(date);
  // 今天是这周的第几天
  var today = date.getDay();
  // 上周日距离今天的天数（负数表示）
  var stepSunDay = -today + 1;
  // 如果今天是周日
  if (today == 0) {
    stepSunDay = -7;
  }
  // 周一距离今天的天数（负数表示）
  var stepMonday = 7 - today;
  var time = date.getTime();
  var monday = new Date(time + stepSunDay * 24 * 3600 * 1000);
  var sunday = new Date(time + stepMonday * 24 * 3600 * 1000);
  // 本周一的日期 （起始日期）
  var startDate = transferDate(monday); // 日期变换
  // 本周日的日期 （结束日期）
  var endDate = transferDate(sunday); // 日期变换
  const dateText = startDate + ' 至 ' + endDate;
  const obj = {
    startDate: startDate,
    endDate: endDate,
    dateText: dateText
  };
  return obj;
}

export function transferDate(date) {
  // 年
  var year = date.getFullYear();
  // 月
  var month = date.getMonth() + 1;
  // 日
  var day = date.getDate();
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  if (day >= 0 && day <= 9) {
    day = '0' + day;
  }
  var dateString = year + '-' + month + '-' + day;
  return dateString;
}
export function fun_date(date, aa) {
  // 传入负数获取前几天日期，传入正数获取后几天日期
  var date1 = new Date(date);
  // var time1=date1.getFullYear()+"-"+(date1.getMonth()+1)+"-"+date1.getDate();//time1表示当前时间
  var date2 = new Date(date1);
  date2.setDate(date1.getDate() + aa);
  // var time2 = date2.getFullYear()+"-"+(date2.getMonth()+1)+"-"+date2.getDate();
  var time2 = transferDate(date2);
  return time2;
}

function stringToDate(dateString) {
  dateString = dateString.split('-');
  return new Date(dateString[0], dateString[1] - 1, dateString[2]);
}

export function countWorkDay(date1, date2) {
  date1 = stringToDate(date1);
  date2 = stringToDate(date2);
  const delta = (date2 - date1) / (1000 * 60 * 60 * 24) + 1; // 计算出总时间

  let weeks = 0;
  for (let i = 0; i < delta; i++) {
    if (date1.getDay() == 0 || date1.getDay() == 6) weeks++; // 若为周六或周天则加1
    date1 = date1.valueOf();
    date1 += 1000 * 60 * 60 * 24;
    date1 = new Date(date1);
  }
  return delta - weeks;
}

// 根据开始和结束时间计算出中间所有的时间
export function getAllDate(start, end) {
  const dateArr = [];
  const startArr = start.split('-');
  const endArr = end.split('-');
  const db = new Date();
  db.setUTCFullYear(startArr[0], startArr[1] - 1, startArr[2]);
  const de = new Date();
  de.setUTCFullYear(endArr[0], endArr[1] - 1, endArr[2]);
  const unixDb = db.getTime();
  const unixDe = de.getTime();
  let stamp;
  const oneDay = 24 * 60 * 60 * 1000;
  for (stamp = unixDb; stamp <= unixDe;) {
    dateArr.push(formatTime(parseInt(stamp)));
    stamp = stamp + oneDay;
  }
  return dateArr;
}
// 获得某月的天数 （与上面有重复可删除，不然本月结束日期报错）
function getMonthDays(nowyear) {
  var lastMonthDate = new Date(); // 上月日期
  lastMonthDate.setDate(1);
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
  var lastMonth = lastMonthDate.getMonth();
  var lastMonthStartDate = new Date(nowyear, lastMonth, 1);
  var lastMonthEndDate = new Date(nowyear, lastMonth + 1, 1);
  var days = (lastMonthEndDate - lastMonthStartDate) / (1000 * 60 * 60 * 24); // 格式转换
  return days;
}

// 获得本月的开始、结束日期
export function getMonthDate() {
  var now = new Date(); // 当前日期
  var nowMonth = now.getMonth(); // 当前月
  var days = getMonthDays(nowMonth) - 1; // 获取当月总共有多少天
  var nowYear = now.getFullYear(); // 当前年(getYear已废弃，所以改成getFullYear)
  // nowYear += nowYear < 2000 ? 1900 : 0;
  return {
    startDate: new Date(nowYear, nowMonth, 1).Format('yyyy-MM-dd'),
    endDate: new Date(nowYear, nowMonth, days).Format('yyyy-MM-dd')
  };
}

// 根据某年某月计算出具体日期
export function getDaysInMonth(year, month) {
  const daysOfMonth = [];
  month = parseInt(month, 10);
  const lastDayOfMonth = new Date(year, month, 0).getDate();
  for (let i = 1; i <= lastDayOfMonth; i++) {
    const newMonth = month < 10 ? `0${month}` : month;
    if (i < 10) {
      daysOfMonth.push(year + '-' + newMonth + '-' + '0' + i);
    } else {
      daysOfMonth.push(year + '-' + newMonth + '-' + i);
    }
  }
  return daysOfMonth;
}

export function getWeekText(dateString) {
  var dateArray = dateString.split('-');
  var date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
  return '周' + '日一二三四五六'.charAt(date.getDay());
}

// 获得本周的开始、结束日期
export function getWeekDate() {
  var now = new Date(); // 当前日期
  var nowDayOfWeek = now.getDay() - 1; // 今天本周的第几天
  var nowDay = now.getDate(); // 当前日
  var nowMonth = now.getMonth(); // 当前月
  var nowYear = now.getFullYear(); // 当前年
  // nowYear += nowYear < 2000 ? 1900 : 0;
  return {
    startDate: new Date(nowYear, nowMonth, nowDay - nowDayOfWeek).Format(
      'yyyy-MM-dd'
    ),
    endDate: new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek)).Format(
      'yyyy-MM-dd'
    )
  };
}

// 创建密码的时候对密码进行校验
export function checkPasswordRule(password) {
  const pwdRegex = new RegExp(
    '(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).'
  );
  if (!pwdRegex.test(password)) {
    return false;
  }
  return true;
}

// 跳转到基础平台 redirectUrl 需要带的路径
export function toBasePlatform(redirectUrl) {
  let baseUrl = `${process.env.VUE_APP_DOMAIN_URL}?token=${localStorage.getItem(
    'loginToken'
  )}`;
  if (redirectUrl) {
    baseUrl += `&redirectUrl=${encodeURIComponent(redirectUrl)}`;
  }
  window.open(baseUrl);
}

// 剪切时间 time 2021.05.06 20:00:00 ===>20:00
export function timeToStr(time) {
  const newTime = /\d{2}:\d{2}/g.exec(time);
  return newTime ? newTime[0] : '-';
}

// 剪切时间 time 2021.05.06 20:00:00===>2021.05.06
export function timeToYearStr(time) {
  const newTime = /\d{4}.\d{2}.\d{2}/g.exec(time);
  return newTime ? newTime[0] : '-';
}

// 获取ip地址
export function getUserIp() {
  return returnCitySN['cip'];
}

// 处理上课时间（课程商品里面的上课时间）
// item 商品列表项
export function dealTimeList(item) {
  const weekListValue = [
    '',
    '周一',
    '周二',
    '周三',
    '周四',
    '周五',
    '周六',
    '周日'
  ];
  let timeStr = '';
  if (item.scheduleRule) {
    const timeInfo = JSON.parse(item.scheduleRule);
    timeInfo.schoolTimeList.forEach((x, y) => {
      const classBegin = timeToStr(x.classTimeBegin);
      const classEnd = timeToStr(x.classTimeEnd);
      if (timeInfo.ruleType === 1) {
        timeStr += `${weekListValue[x.weekDate ? x.weekDate : 0]}`;
      } else {
        timeStr += `${
          weekListValue[x.weekDate ? x.weekDate : 0]
        } (${classBegin}-${classEnd})`;
      }
      if (y < timeInfo.schoolTimeList.length - 1) {
        timeStr += '、';
      }
      if (y === timeInfo.schoolTimeList.length - 1 && timeInfo.ruleType === 1) {
        timeStr += ` ${classBegin}-${classEnd}`;
      }
    });
  }
  return timeStr || '-';
}

// 判断日期是否在本月之前
// dateStr xxxx-xx-xx
export function judgeDateIsBeforeNowMonth(dateStr) {
  const now = new Date(); // 当前日期
  const nowMonth = now.getMonth(); // 当前月
  const nowYear = now.getFullYear();
  const strDateInfo = new Date(dateStr);
  const strMonth = strDateInfo.getMonth();
  const strYear = strDateInfo.getFullYear();
  if (strYear < nowYear) {
    return true;
  }
  if (strYear > nowYear) {
    return false;
  }
  if (strMonth < nowMonth) {
    return true;
  }
  return false;
}

// Find components downward
export function findComponentsDownward(context, componentName) {
  return context.$children.reduce((components, child) => {
    // console.log(child.$options.name);
    if (child.$options.name === componentName) components.push(child);
    const foundChilds = findComponentsDownward(child, componentName);
    return components.concat(foundChilds);
  }, []);
}

export function editorGetText(str) {
  return str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi, '');
}
export function editorIsNull(str) {
  if (str === '') return true;
  var regu = '^[ ]+$';
  var re = new RegExp(regu);
  return re.test(str);
}

export function isPassExpectTime(initTime, expectMinute) {
  let time = initTime.split(' ').length > 1 ? initTime : initTime + '00:00:00';
  time = time.replace(/-/g, '/');
  const timeStamp = Date.parse(time);
  const expectMinuteTimeStamp = expectMinute * 60 * 1000;
  const timeStampExpect = timeStamp - expectMinuteTimeStamp;
  const curTime = new Date().getTime();
  // console.log(new Date(timeStampExpect), timeStampExpect, curTime);
  console.log(initTime, curTime, timeStampExpect, '======43242');
  if (curTime >= timeStampExpect) {
    return true;
  } else {
    return false;
  }
}

/**
 * @author: gauharchan
 * @description 转化为百分比
 * @param {string | number} val 值
 * @param {string | undefined} unit 单位
 */
export function toPercent(val, unit) {
  const value = (val / 100).toFixed(1);
  return unit ? `${value}${unit}` : value;
}
/**
 * @author: gauharchan
 * @description 每三位数以逗号分隔
 * @param {string} value 值
 */
export function priceFormat(value) {
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// 对象按字段赋值
export function objAssign(objA, objB) {
  console.log(' Object.keys(objA)', Object.keys(objA));
  Object.keys(objA).forEach((key) => {
    objA[key] = objB[key] || objA[key];
    objA[key] = objA[key] === '' ? null : objA[key];
  });
}

export function fliterPhone(phone) {
  const reg = /^(\d{3})\d{4}(\d{4})/;
  return phone.replace(reg, '$1****$2');
}
// 金额 分转换成元，并增加, 号效果
export function abs(val) {
  const str = (val / 100).toFixed(2) + '';
  const intSum = str
    .substring(0, str.indexOf('.'))
    .replace(/\B(?=(?:\d{3})+$)/g, ','); // 取到整数部分
  const dot = str.substring(str.length, str.indexOf('.')); // 取到小数部分搜索
  const ret = intSum + dot;
  return ret;
}

// 获取最大与最小的年级排列
export function getGradeMinAndMax(min, max, showStr = false, short = false) {
  let gradeMin = min;
  let gradeMax = max;
  const kindergarten = [13, 14, 15];
  const case1 =
    gradeMax > gradeMin &&
    kindergarten.includes(gradeMax) &&
    !kindergarten.includes(gradeMin);
  const case2 =
    gradeMin > gradeMax &&
    !kindergarten.includes(gradeMin) &&
    !kindergarten.includes(gradeMax);
  if (case1 || case2) {
    gradeMax = min;
    gradeMin = max;
  }
  if (!showStr) {
    return {
      gradeMax,
      gradeMin
    };
  } else {
    if (short) {
      return gradeMin === gradeMax
        ? `${gradeStrListshort[gradeMin]}`
        : `${gradeStrListshort[gradeMin]}-${gradeStrListshort[gradeMax]}`;
    } else {
      return gradeMin === gradeMax
        ? `${gradeStrList[gradeMin]}`
        : `${gradeStrList[gradeMin]}-${gradeStrList[gradeMax]}`;
    }
  }
}

// 检查是否是输入两位小数的正数值
export function checkNum2Decimals(str, errorStr) {
  const checkStr = String(str);
  if (checkStr === '') {
    return {
      code: 500,
      error: '请输入减免金额'
    };
  }
  let length = 0;
  const arr = checkStr.split('.');
  if (arr.length === 2) {
    length = arr[1].length;
  }

  if (Number.parseFloat(checkStr) <= 0) {
    return {
      code: 500,
      error: `${errorStr}请输入大于0的金额`
    };
  } else if (length > 2) {
    return {
      code: 500,
      error: `${errorStr}最多只能输入两位小数的金额`
    };
  } else if (arr.length > 2) {
    return {
      code: 500,
      error: `${errorStr}只能输入一个小数点`
    };
  } else if (isNaN(checkStr)) {
    return {
      code: 500,
      error: `${errorStr}只能输入数字`
    };
  }
  return {
    code: 200
  };
}

// 检查是否是输入两位小数的正数值包括0
export function checkNum2DecimalsAnd0(str, errorStr) {
  const checkStr = String(str);
  if (checkStr === '') {
    return {
      code: 500,
      error: '请输入减免金额'
    };
  }
  let length = 0;
  const arr = checkStr.split('.');
  if (arr.length === 2) {
    length = arr[1].length;
  }

  if (length > 2) {
    return {
      code: 500,
      error: `${errorStr}最多只能输入两位小数的金额`
    };
  } else if (arr.length > 2) {
    return {
      code: 500,
      error: `${errorStr}只能输入一个小数点`
    };
  } else if (isNaN(checkStr)) {
    return {
      code: 500,
      error: `${errorStr}只能输入数字`
    };
  }
  return {
    code: 200
  };
}

export function judgeIsNumber(value) {
  var rule = /^[0-9]*$/;
  var judgeNumer = new RegExp(rule);
  return judgeNumer.test(value);
}

// 要传给接口的金额数据，需要涉及到元转分的
export function apiPostMoneyYuanChangeFen(money) {
  if (isNaN(+money)) {
    return 0;
  }
  return new BigNumber(+money).multipliedBy(100).toString();
}

// 将分转成元 并增加, 号效果
export function moneyFenChangeYuan(money) {
  if (isNaN(+money)) {
    return 0;
  }
  const newNum = new BigNumber(+money).dividedBy(100).toString();
  const str = (+newNum).toFixed(2) + '';
  const intSum = str
    .substring(0, str.indexOf('.'))
    .replace(/\B(?=(?:\d{3})+$)/g, ','); // 取到整数部分
  const dot = str.substring(str.length, str.indexOf('.')); // 取到小数部分搜索
  const ret = intSum + dot;
  return ret;
}

// 如果传入的参数是一个字符串，那么可以处理任意长度的数字。如果传入的参数是一个数字，那么将使用 JavaScript 默认的 Number 类型，可能会有精度损失。
// 加法 +
export function add(numL, numR) {
  const a = new BigNumber(numL);
  const b = new BigNumber(numR);
  return a.plus(b).toString();
}
// 减法 -
export function minus(numL, numR) {
  const a = new BigNumber(+numL);
  const b = new BigNumber(+numR);
  return a.minus(b).toString();
}
// 乘法 *
export function mut(numL, numR) {
  const a = new BigNumber(+numL);
  const b = new BigNumber(+numR);
  return a.multipliedBy(b).toString();
}
// 除法 /
export function dev(numL, numR) {
  const a = new BigNumber(+numL);
  const b = new BigNumber(+numR);
  return a.dividedBy(b).toString();
}

// 剪切时间 time 2021.05.06 20:00:00===>2021.05.06
export function yearMonthSplit(time) {
  const newTime = /\d{4}-\d{2}/g.exec(time);
  return newTime ? newTime[0] : '-';
}
// 跳转到对账中心 redirectUrl 需要带的路径
export function toReconciliationCenter(redirectUrl) {
  let baseUrl = `${process.env.VUE_APP_RECONCILIATION_URL}?token=${localStorage.getItem(
    'loginToken'
  )}`;
  if (redirectUrl) {
    baseUrl += `&redirectUrl=${encodeURIComponent(redirectUrl)}`;
  }
  window.open(baseUrl);
}

export function refundErrTextDeal(errorText) {
  const reg = /请款单状态错误，请款项移除失败，请款单号：(\d+)，请款项编号：(\d+)/;
  return errorText.replace(reg, '$1&$2');
}

export function confirmErrTextDeal(errorText) {
  const reg = /请款单状态错误，请款项退款失败，请款单号：(\d+)，请款项编号：(\d+)/;
  return errorText.replace(reg, '$1&$2');
}

export function dealErrText(errorText) {
  const re = /\d+/g;
  const result = re[Symbol.matchAll](errorText);

  return Array.from(result, (x) => x[0]);
}

export function getMonthsBetweenDates(startMonth, endMonth) {
  const months = [];
  const startDate = new Date(startMonth);
  const endDate = new Date(endMonth);
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    const month = currentDate.getMonth() + 1;
    months.push(`${month}`);
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return months;
}

export function getYearMonthDate(time) {
  if (!time) {
    return {};
  }
  const currentTime = new Date(time);
  const year = currentTime.getFullYear();
  const month = currentTime.getMonth() + 1;
  const date = currentTime.getDate();
  return {
    year,
    month,
    date
  };
}

export function getSortDate(dateList) {
  const dateNew = dateList.map(item => {
    return new Date(item);
  });
  dateNew.sort((a, b) => a - b);
  return dateNew.map(item => {
    return item.Format('yyyy-MM-dd');
  });
}

// 校验时间范围是否有交集
export function checkTimeRangehasIntersection(rangeA, rangeB) {
  const rangeAStart = new Date(`1970/01/01 ${rangeA[0]}`).getTime();
  const rangeAEnd = new Date(`1970/01/01 ${rangeA[1]}`).getTime();
  const rangeBStart = new Date(`1970/01/01 ${rangeB[0]}`).getTime();
  const rangeBEnd = new Date(`1970/01/01 ${rangeB[1]}`).getTime();
  if (rangeBStart === rangeAStart && rangeBEnd === rangeAEnd) {
    return true;
  }
  if ((rangeBStart >= rangeAStart && rangeBStart < rangeAEnd) || (rangeBEnd > rangeAStart && rangeBEnd <= rangeAEnd) || (rangeAStart >= rangeBStart && rangeAStart < rangeBEnd) || (rangeAEnd > rangeBStart && rangeAEnd <= rangeBEnd)) {
    return true;
  } else {
    return false;
  }
}
